import { Checkbox } from '@/components/ui/checkbox'
import { FilterSection } from './FilterSection'
import { Clock } from 'lucide-react'

interface FilterSectionSourcesProps {
  sources: { id: string; name: string }[]
  selectedIds: string[]
  loading: boolean
  onToggle: (id: string, checked: boolean) => void
}

export function FilterSectionSources({
  sources,
  selectedIds,
  loading,
  onToggle,
}: FilterSectionSourcesProps) {
  return (
    <FilterSection icon={Clock} label="Fontes">
      <div className="space-y-2 max-h-48 overflow-y-auto">
        {loading ? (
          <div className="text-sm text-gray-500">Carregando...</div>
        ) : (
          sources.map((source) => (
            <div key={source.id} className="flex items-center space-x-2">
              <Checkbox
                id={`source-${source.id}`}
                checked={selectedIds.includes(source.id)}
                onCheckedChange={(checked) => onToggle(source.id, checked === true)}
              />
              <label
                htmlFor={`source-${source.id}`}
                className="text-sm cursor-pointer"
              >
                {source.name}
              </label>
            </div>
          ))
        )}
      </div>
    </FilterSection>
  )
}
